import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner2-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./MediationProcessPage.scss";

const MediationProcessPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("process_page_header")}</h1>
          <p className="banner-subtitle">{t("process_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_process_page_link1")}</Link>
        <span>{t("breadcrumbs_process_page_span")}</span>
        <Link>{t("breadcrumbs_process_page_link2")}</Link>
      </Breadcrumbs>
      <main className="mediation-process-main-container">
        <section className="mediation-process-slider-section">
          <Carousel className="mediation-process-carousel">
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img1")}
                alt="Mediation process step 1"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img2")}
                alt="Mediation process step 2"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img3")}
                alt="Mediation process step 3"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img4")}
                alt="Mediation process step 4"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img5")}
                alt="Mediation process step 5"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img6")}
                alt="Mediation process step 6"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img7")}
                alt="Mediation process step 7"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img8")}
                alt="Mediation process step 8"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={t("process_slider_img9")}
                alt="Mediation process step 9"
              />
            </Carousel.Item>
          </Carousel>
        </section>
      </main>
      <div className="temporary">
        <img id="res-img" src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default MediationProcessPage;
